import { Row, Col, Modal } from 'react-bootstrap';
import {
  HeadingDesc,
  HeadingDescSmall,
  HeadingWithSpaceLarge
} from '../../Headings';
import { RatingStars } from '../../rating';
import './readReviewsModal.css';

function ReadReviewsModal(props) {
  const { show, close } = props;

  return (
    <Modal
      show={show}
      className="modalLayout ratingModal"
      onHide={close}
      centered
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton onHide={close}>
        <div>
          <HeadingWithSpaceLarge text="YOUR REVIEW" />
          <HeadingDescSmall text="You can share your records with the doctors you have visited." />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="content">
          <Row>
            <Col md={6}>
              <div className="ratingBox">
                <HeadingDesc text="Wait Time" />
                <RatingStars edit />
              </div>
              <div className="ratingBox">
                <HeadingDesc text="Cleanliness" />
                <RatingStars edit />
              </div>
            </Col>
            <Col md={6}>
              <div className="ratingBox">
                <HeadingDesc text="Bedside Manners" />
                <RatingStars edit />
              </div>
              <div className="ratingBox">
                <HeadingDesc text="Staff Friendliness" />
                <RatingStars edit />
              </div>
            </Col>
            <Col md={12}>
              <div className="reviw">
                <div>
                  <HeadingDescSmall text="Staff was great,Zeke the assistant was amazing. Augustin the hygenist did a great job on my cleaning. Melissa and Jennifer made sure I understood my treatment plan." />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ReadReviewsModal;
